var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.100098 1.93377V23.2664C0.100031 23.5037 0.163262 23.7366 0.283268 23.9413C0.403273 24.1459 0.575706 24.3148 0.782776 24.4306C0.989846 24.5463 1.22405 24.6048 1.46124 24.5998C1.69842 24.5949 1.92998 24.5267 2.13204 24.4024L19.4648 13.7361C19.659 13.6168 19.8193 13.4497 19.9305 13.2509C20.0417 13.052 20.1001 12.8279 20.1001 12.6001C20.1001 12.3722 20.0417 12.1482 19.9305 11.9493C19.8193 11.7505 19.659 11.5834 19.4648 11.4641L2.13204 0.797801C1.92998 0.673491 1.69842 0.605343 1.46124 0.600389C1.22405 0.595434 0.989846 0.653852 0.782776 0.769616C0.575706 0.88538 0.403273 1.0543 0.283268 1.25894C0.163262 1.46358 0.100031 1.69653 0.100098 1.93377Z",
    fill: "#FDFDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play-button.d72233e438ec66f20bcfd29e0a1f1ac6.svg";
export { ForwardRef as ReactComponent };